import { SurveyEntity } from './survey-entity';

export class SurveyList {
  public surveys: SurveyEntity[] = [];
}
